var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isComments)?_c('section',{staticClass:"mb-5 d-flex flex-column"},[_c('span',{staticClass:"melia mb-2"},[_vm._v("Комментарии возврата")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.comments)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }